import React, {Component, useMemo,useEffect,useState} from 'react'
import {
		Table,
		Popup,
		Button,
		Menu,
		Dropdown,
		Input,
		Image,
		Icon,
		Select,
		Loader,
		Container,
		Tab,
		Checkbox,
		Confirm,
	} from 'semantic-ui-react'
import { ObjectInspector, chromeLight } from 'react-inspector';
import { Helmet } from "react-helmet"
import {DataShow} from 'xAppLib/DataTable'
import ActBtns from 'views/UIelems/fields/ActBtns'
import { AsyncButton } from "../UIelems/AsyncButton";
import instcons_global_model from "../../models/instcons_global_model";
import {cls} from "../NUI/utils";
import { useCallback } from 'react';
import { useSiteStatus, useUserData } from 'xAppLib/Hooks';
import { Link } from 'react-router-dom';
import Badge from 'views/NUI/Badge';
import {DataConnector, ListTable, ListFilters, ListPagination} from 'xAppLib/DataTable'
import OverlayDialog from './OverlayDialog';
import { useCanApprove } from './Hooks';
import API_service from 'xAppLib/providers/API_service';
import { CheckIcon } from '@heroicons/react/outline'
import { useRef } from 'react';


const DEBUG = false

const MAX_REVIEW_TIME = 1000 * 60 * 2 // 2 minutes
const ENFORCE_REVIEW = false;

const WrapComponent = ({embedded,children}) => embedded 
			? <div>{children}</div> 
			: <Container className='wide-content' fluid>
				{children}
			</Container>

function WR({embedded, title = "WR"}) {

	const [data_loaded, setDataLoaded] = useState(false)
	const [records] = useUserData('approval',null)

	const [page,setPage] = useState(1)
	const [refresh,setRefresh] = useState(0)
	const [pageSize,setPageSize] = useState(5)

	const [checked,setChecked] = useState({})

	const can_approve = useCanApprove()

	const timers = useRef({})

	
	DEBUG && console.log("WR Records",records);
	
	useEffect(()=>{
		if (!records)
			return
		for (const r of records) {
			if (!r.owner && timers.current[r.sid]) 
				clearTimer(r.sid)
		}
	},[records])


	// tracking live time for distance from the initial assignment of a script (rev_tm)
	const [currentTime, setCurrentTime] = useState(new Date());
    useEffect(() => {
        const intervalHandle = setInterval(() => {
            setCurrentTime(() => new Date());
        }, 1000);
        return () => clearInterval(intervalHandle);
    }, []);
	const clearTimer = useCallback(async sid=>{
		if (!timers.current[sid])
			return
		clearTimeout(timers.current[sid])
		delete timers.current[sid]
	},[])

	const own = useCallback(async sid=>{
		clearTimer(sid)
		await instcons_global_model.own(sid)
		timers.current[sid] = setTimeout(async ()=>{
			const latest = await instcons_global_model.get_record(sid,null,{refresh:true})
			if (!latest)
				return
			if (latest.status == 'auto_approved_delay' && latest.owner?.uid == app.user.uid && !latest.pending) {
				instcons_global_model.own(sid,false)
			}
		},MAX_REVIEW_TIME)
	},[])


	const onAct = useCallback(async (row, act, params) => {

		DEBUG && console.log('onAct', row, act,params);

		switch(act) {

			case 'approve':
				await instcons_global_model.update_status(row,'doc_approved', {is_scr: true, eml: true},);
				break;

			case 'reject':
				await instcons_global_model.update_status(row,'doc_declined', {is_scr: false, eml: true, ...params},);
				break;

			case 'review': {
				await own(row.sid)
				break;
			}
			case 'return': 
				await instcons_global_model.own(row.sid,false)
				break;
			
			case 'script note': {
				
				const result = await API_service.load_data('chgStat', {sid: row.sid, stat: act, ...params}) 
				return result;
			}

		}

		return {res: 'ok'};

	},[])

	if (!can_approve)
		return null


	return <WrapComponent embedded={embedded}>

				<h3>{title}</h3>


				<DataConnector
						pageSize={pageSize}
						page={page}
						refresh={refresh}
						data={ records }
						>

					{ (data, loading, pages, total, pageSize) => {
						const selected = Object.keys(checked).filter(k=>{
							const r = data.find(r=>r.sid==k)
							if (!r)
								return false
							const mine = r.owner?.uid == app.user.uid
							const owned = r.owner?.uid && !mine
							return checked[k] && !owned && (!(r.must_review && ENFORCE_REVIEW) || mine);
						})

						return <>
							
							<Table selectable compact className='approve-wr'>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>
											{/* <Checkbox onClick={(e,d)=>{
												setChecked(data.reduce((o,r)=>({...o,[r.sid]:d.checked}),{}))
											}}/> */}
										</Table.HeaderCell> 
										{
											instcons_global_model.LIST_DET_FIELDS.map(
																	(f, i) => <Table.HeaderCell key={`tbl_hdr_${i}`}>{f.name}</Table.HeaderCell>
																)
										}
										{!app.acl.is_supp && <Table.HeaderCell>Act btns</Table.HeaderCell>}
										{(app.acl.is_admin || app.acl.is_supp) && <Table.HeaderCell>Raw data</Table.HeaderCell>}
									</Table.Row>
								</Table.Header>

								<Table.Body>
									{loading && <Table.Row><Table.Cell singleLine><Loader active inline/></Table.Cell></Table.Row>

									|| 
										(data.length > 0 &&
											data.map(
												(r, i) => {

													// return <Table.Row><Table.Cell>Data</Table.Cell></Table.Row>
													const mine = r.owner?.uid == app.user.uid
													const owned = r.owner?.uid && !mine
													const pending = !!r.pending || r.loading
													const blocked = pending || owned
													const can_approve = !owned && (mine || !(r.must_review && ENFORCE_REVIEW));
													// lockTimer starts at the MAX_REVIEW_TIME (120) seconds and count towards enabling the unlock feature
													const lockTimer = ((new Date(r.rev_tm + MAX_REVIEW_TIME) - currentTime) / 1000);
													const rowStyle = cls('relative',
																				{
																					'bg-slate-50': !!(i % 2),
																					"opacity-40":owned,
																					admin:(app.acl.is_admin || (lockTimer <= 0 && app.acl.is_supp)),
																					mine,
																					owned,
																					blocked,
																					pending
																				}
																				)
													const borderStyle = cls('border-l-4 border-transparent',
																			mine && "border-emerald-400" ,
																			owned && "border-gray-400",
																			// blocked && "pointer-events-none"
																			)
													const type = (['escript', 'c2u', 'home'].includes(r.form_data?.delivery)?'eScript':'Paper script')
													return <Table.Row
																key={"view-rec-"+r.key}
																className={rowStyle}
																>

																<Table.Cell className={borderStyle}>
																	{/* <Checkbox
																		disabled={!can_approve}
																		onChange={(e, data) => setChecked(checked=>({...checked,[r.sid]:data.checked}))}
																		checked={selected.includes(r.sid)}
																		label={i+1}/> */}
																	{/*app.acl.is_admin && <> ({touch_count(r)})</>*/}
																	{owned && <Icon name='lock' size='large' />}
																	{pending && <Icon size='large' name='spinner' loading />}

																</Table.Cell>
																{/*<Table.Cell content={Object.values(recs_data).length-i} />*/}

																{/*<Table.Cell>
																	<Image avatar src={r.photoURL} />
																</Table.Cell>*/}

																{instcons_global_model.LIST_DET_FIELDS.map((f, fi) => (
																	<Table.Cell key={`tbl_val_${r.key}_${fi}`}>
																		{DataShow.show_data_field(r, f, null, null, null, null, {})}
																	</Table.Cell>
																))}

																{!app.acl.is_supp && <Table.Cell>
																			<ActBtns 
																				as={AsyncButton}
																				show_stat={false}
																				row={r} 
																				f={{
																						name: 'Status',
																						btns_list_func: (row) => {

																								const btns_arr = [

																									can_approve && mine &&  { n:'Approve '+ type, a:'approve',
																										c:'green', i:'check'
																									},
																									can_approve && mine &&  {	n:'Reject '+ type, a:'reject',
																										cust:'stat_w_msg', pl_hld:'Reason to reject (min 30 characters)',
																										c:'red', i:'exclamation',
																										min_len:30,
																									},
																									!mine && !owned && {	n:'Review', a:'review',
																										c:'orange', i:'question'
																									},
																									can_approve && mine && {n:'add note', a:'script note', cust:'stat_w_msg', pl_hld:'Add Note', info:r=>r.meta?.note, c:'olive', i:'write'},
																									mine && {	n:'Return', a:'return',
																										c:'yellow', i:'recycle'
																									},
																								].filter(Boolean);

																								return btns_arr;
																							},

																						btns_stat_param: 'status',
																						btns_stat_dict: (stat) => {

																								if (['done_doccall'].includes(stat))	return 'Consult finished';

																								return stat==null ? 'not set' : stat
																							},
																						act_run: async (b, row, mod) => onAct(row, b.a, b.p),
																						onClickBtn:(b,act) => {
																							if (!['review','return'].includes(b.a))
																								own(r.sid)
																							// console.log("onClickBtn",b.a,{b});
																						}
																					}}
																				/>
																</Table.Cell>}

																{(app.acl.is_admin || app.acl.is_supp) && 
																<Table.Cell>

																	{app.acl.is_admin && <Popup
																			trigger={<Button icon='add' size='tiny' />}
																			position='left center'
																			on='click'
																			style={{height: '80%', width: '80%', minWidth: 700, overflow: 'scroll'}}
																	>
																		<div>
																			<br/>
																				<ObjectInspector
																						data={ r }
																						expandLevel={ 2 }
																						theme={{...chromeLight, ...({ TREENODE_PADDING_LEFT: 20 })}}
																					/>
																			<br/>
																		</div>

																	</Popup>}

																	{owned && <Button 
																		color='red'
																		icon={lockTimer <= 0 && 'lock open' || undefined} 
																		size='tiny'
																		style={{
																			width: "44px"
																		}}
																		onClick={async ()=>{
																			if (await app.confirm(`Unlock?`, `This will remove ownership on the record.` ) == 'yes')
																					instcons_global_model.update_record(r.sid,
																						{
																							pending:false,
																							owner:null
																						})
																			}}
																	>{lockTimer > 0 && `${lockTimer.toFixed(0)} ` || undefined}</Button>}



																</Table.Cell>}

																
															</Table.Row>
												})
										||
											<Table.Row>
												<Table.Cell colSpan='5' className='text-green-600'><Icon name='check'/> No records</Table.Cell>
											</Table.Row>)
									}

								</Table.Body>

								{/* <Table.Footer>
									<Table.Row>
										<Table.HeaderCell colSpan={50}>
												<Button color='green' disabled={selected.length==0} icon='check' content='Approve All' size='mini' onClick={()=>{
													const rows = data.filter(r=>selected.includes(r.sid))
													rows.map(row=>instcons_global_model.update_status(row,'doc_approved', {is_scr: true, eml: true}))
												}} />
										</Table.HeaderCell>
									</Table.Row>
								</Table.Footer> */}
							</Table>

							{pages > 1 && <ListPagination 
										page={page} 
										pages={pages} 
										pageSize={pageSize}
										loading={loading} 
										data={data} 
										total={total} 
										boundaryRange={3}
										pageSizeOptions={[5,10,20]}
										showPageSizeSelector={true}
										onPageSizeChange={pageSize=>setPageSize(pageSize)}
										onPageChange={page=>setPage(page)}/>}

						</>
					}}
				</DataConnector>

			

			
		</WrapComponent>;
}

export default React.memo(WR)

export const AppScriptsCount = () => useUserData('approval')[0]?.length || 0;

export const ApprovalBadge = () => {
	const [records, setRecords] = useUserData('approval',null)
	const [open,setOpen] = useState(false)

	const can_approve = useCanApprove()

	if (!can_approve)
		return null
	return <>
		<Badge title='Pending Scripts Approvals' color={records?.length ? 'red' : 'green'}  onClick={()=>setOpen(true)} className='cursor-pointer'>{records?.length || <CheckIcon className="h-4 w-4" />}</Badge>
		{open && <OverlayDialog open={open} setOpen={setOpen} closeButton>
			<div className='text-sm'>
				<WR embedded title={null}/>
			</div>
		</OverlayDialog>}
	</>	
}
